const SVG_HEADER = `<?xml version="1.0" encoding="UTF-8" standalone="no"?>
<svg xmlns:svg="http://www.w3.org/2000/svg"
    xmlns="http://www.w3.org/2000/svg" id="svg2" version="1.1"
    width="{width}" height="{height}">
<metadata id="metadata4933"/>
<defs id="defs4"/>
`;

export default SVG_HEADER;



// WEBPACK FOOTER //
// ./src/app/misc/svg-header.ts